export const errorCodes = {
  AE11000: "No Security Credentials Found",
  AE11001: "Credential Allocation Failure",
  AE11007: "Incorrect version of ADT",
  AE11014: "Not Device Owner",
  AE11015: "Value Based Check Breach",
  AE11025: "Unable to decrypt the message",
  AE11026: "Adapter Parse Fail Invalid Data Returned",
  AE11027: "Firmware associated device information not included",
  AE11028: "External Service Returned HTTP 500 Error",
  BE10001: "No ESME found",
  BE10002: "No GSME found",
  BE10003: "Duplicate active BOL request",
  BE10009: "BOL event timed out",
  BE10027: "Preceding Scenario Timeout",
  BE10028: "No device ID is found",
  BE10030: "Invalid PSP Processing Code",
  BE10031: "Certificate Application Failure",
  BE10032: "Device Status Invalid",
  BE10034: "Invalid Payment Mode",
  BE10036: "PAN already exists",
  BE10037: "PAN already exists",
  BE10038: "Specified PAN not found",
  BE10039: "No PAN found",
  BE10040: "Top Up alert logged",
  BE10041: "Invalid TPR",
  BE10042: "PAN Inactive",
  BE10044: "Expected CoS Gain request not received",
  BE10045: "Payment Mode Invalid",
  BE10047: "Source ID and Source Counter not unique",
  BE10048: "Adapter quarantine release failed",
  BE10050: "UTRN receipt not confirmed by PSP",
  BE10051: "Invalid Instruction",
  BE10052: "Device Type Not ESME/GSME",
  BE10053: "Invalid Commission Status",
  BE11008: "CoT Date in the Future",
  BE11010:
    "Alert with no matching BOL device record or a device record does exist but is not associated to a premise",
  BE11011: "No known Schedule Id for Alert",
  BE11012: "No known Request Id for Alert",
  BE11013: "Device Alert for Lost Device (not lost to NGIS)",
  BE11016: "Order not found in SAT",
  BE11017: "Device Already Rejected/Returned",
  BE11018: "Device Already found in BOL",
  BE12001: "Non-Disablement ID was not found for Device ID",
  BE12005: "Device Firmware not on Certified Products List",
  BE12007: "Device is configured to an Invalid Payment Mode",
  BE12009: "ReadLogPeriod exceeds data stored at Device",
  BE12010: "Verification of MPxN or Device ID invalid",
  BE12017: "Invalid DSPScheduleID Provided",
  BE12018: "Invalid DeviceID",
  BE12019: "Invalid DeviceID - MPAN Relationship",
  BE12021: "No SupplyState Returned",
  BE12023: "Verification of Supplier invalid",
  BE12024: "Invalid commodity for SR",
  BE12027: "Incorrect Billing Period Start Date",
  BE13000: "Invalid Agent MPID(s)",
  BE13001: "Appointment Date Invalid",
  BE13002: "MPxN not found in AFMS",
  BE13003: "Supply Not Live",
  BE13004: "Invalid Agent Appointed",
  BE13005: "WAN Matrix not Present",
  BE13006: "Device Type Already Present",
  BE13007: "AFMS Batch Not Received",
  BE13011: "Invalid Agent",
  BE13013: "No Tariff Configuration Received",
  BE13014: "No default tariff configuration available",
  BE13015: "Correct GNO or their credentials cannot be located",
  BE13018: "Device Rejects Time",
  BE13020: "Max Type 2 Devices Found",
  BE13024: "Mandatory Fields not Present",
  BE13026: "Unable to determine Network Operator",
  BE13027: "Top Up Device Unsuccessful/Top Up Application Timeout",
  BE13028: "CPL in Invalid Format",
  BE13031: "Firmware response timeout",
  BE13032: "Invalid Supplier ID",
  BE13033: "Invalid Device ID",
  BE13037: "No appointment found",
  BE13038: "Incompatible Appointment Status",
  BE13040: "Invalid Supplier ID",
  BE13042: "Unable to Retrieve Installation Readings",
  BE13043: "No Readings to Output",
  BE13044: "Invalid Supplier Reference",
  BE13045: "Invalid Supplier ID",
  BE13046: "Device Not Found",
  BE13047: "Invalid Postcode",
  BE13049: "CHFDeviceID Invalid",
  BE13050: "Verification of DeviceID Invalid",
  BE13052: "InstallCode Not Found",
  BE13053: "Other Device Not in Device Log",
  BE13054: "Join Not Removed",
  BE13057: "Master ASN Store Unavailable",
  BE13058: "Unable to Create ScheduleID",
  BE13059: "Firmware Verification Failure",
  BE13060: "Firmware Activation Failed",
  BE13062: "Invalid EUI in Trust Anchor Cell",
  BE13063: "Update Security Credentials Failed",
  BE13065: "Device Type Validity",
  BE13068: "N25 Pairing Failure Alert Received",
  BE13069: "Adapter did not recognise device",
  BE13076: "No PAN provided on IN file",
  BE13080:
    "Read Billing Calendar payload returned contains No 'Billing Calendar'",
  BE13081:
    "Read Billing Calendar payload data differs from the data already stored in the MDS",
  BE13083: "Read Payment Mode payload returned contains No 'Payment Mode'",
  BE13084:
    "Read Payment Mode data differs from the data already stored in the MDS",
  BE13085:
    "Retrieve Security Credentials payload returned contains No 'Security Credentials'",
  BE13091: "Message Status False",
  BE13092: "Read Pre-Payment Has Not Returned Data",
  BE13093:
    "Read Device Configuration (Gas) - Calorific Value and Conversion Factor (GSME) Has Not Returned Data",
  BE13094: "Device ID / Supplier Validation",
  BE13096: "Active Registers do not exist that match the request",
  BE14000: "Invalid PartyID provided",
  BE14001: "PartyID not provided",
  BE14002: "No Billing Calendar Info",
  BE14004: "No Reading Returned",
  BE14005: "Read Voltage payload returned contains No 'Voltage' data",
  BE14006:
    "Read Randomisation payload returned contains No 'Randomisation' data",
  BE14007: "Read Identity payload returned contains No 'Identity' data",
  BE14008:
    "Read Instantaneous Power Threshold payload returned contains No 'Instantaneous Power Threshold' data",
  BE14009: "Read MPxN payload returned contains No 'MPxN' data",
  BE14010:
    "Read Gas Configuration payload returned contains No 'Gas Configuration' data",
  BE14019: "Read MPxN Not Stored MPxN",
  BE14020:
    "The Requestor of the Device Security Credentials is not the current supplier of the Device",
  BE14024: "Unable to store read",
  BE14025: "CPL/ASN Update Failure",
  BE14028: "No Credentials Requested",
  BE14029: "Firmware Image Not on CPL",
  BE14030: "Firmware Image Removed from CPL",
  BE14031: "No Firmware Image Found",
  BE14034: "Associated GPF not present",
  BE14035: "GPF Device ID provided for a device that is not a CHF",
  BE14039: "No Update to Settlement State",
  BE14040: "No Payload when issuing security credentials",
  BE14042: "CSR Failure for one CSR request",
  BE14044:
    "Unsuccessful response returned when issuing or updating security credential in the XSECR process",
  BE14046: "CHF & ESME Not Valid",
  BE14047: "The Device ID For CHF doesn't exist",
  BE14048: "The Device ID For HCALCS doesn't exist",
  BE14050: "Invalid Primary MPAN",
  BE14051: "Secondary MPAN supplied",
  BE14053: "Missing Channel Values - North Region",
  BE14054:
    "The 'LimitedCriticalDutyCycleThreshold' must be greater than the 'NormalLimitedDutyCycleThreshold'",
  BE14055: "Maximum number of HCALCS reached",
  BE14056: "No Existing HCALCS",
  BE14057: "No option fields have been populated in the IN_File",
  BE14058: "GBCS Version Less Than 2.0",
  BE14059: "Message status = 'true' but no data is returned",
  BE14060: "Device type must be CHF",
  BE14061: "Unable to set Secondary tariff",
  BE14062: "Unable to set Secondary price",
  BE14064: "Standing charge value exceeds xs:Short max value of 32767",
  BE14065: "Secondary MPAN not returned but included in IN_FILE",
  BE14067: "Information required for GBCS Version not provided",
  BE14069: "CHF Channel Scan Assessment Failure - Retry Status Code Received",
  BE14070: "SR Timeout",
  BE14074: "Certificate Replacement Failed due to 'badCertificate'",
  BE14075:
    "Certificate Replacement Failed due to 'noTrustAnchor' or 'insufficientMemory'",
  BE14076:
    "Certificate Replacement Failed due to multiple failed attempts where the 'ReplacementOutcome' was either 'resourcesBusy' or 'other'",
  BE14077: "Certificate combination of DCC and Supplier",
  BE14082: "No alerts have been provided",
  BE14085:
    "Unable to activate firmware due to no firmware image with a firmware status that is not 'inactive' being found",
  BE14086: "Firmware Upgrade not found",
  BE14087: "Firmware version has not been updated",
  BE14089: "Active Firmware Batch name does not exist",
  BE14090: "Firmware Batch already initiated",
  BE14091: "Service Request Did Not Return MPxN",
  BE14092: "No EUI-64 for MPxN Provided",
  BE14096: "No MSN present at the premise",
  BE14097: "Duplicate Device ID provided in AI_01 file",
  BE14099: "SRV not supported",
  BE14101: "Non Numeric MPxN received",
  BE14103:
    "Check that the EUI-64 provided is a valid EUI-64 that we currently hold for the Supplier and fuel (System Param / EUI-64 Identity Table)",
  BE14104: "More than 4 Security Log Entries Returned",
  BE14105: "ESME Variant Not Provided For ESME Device Type",
  BE14108: "Requested action invalid for device type",
  BE14109: "Cannot Find Previous Tariff Details",
  BE50042:
    "Secondary Tarff Data provided on the IN_FILE but no secondary MPAN exists within the BOL",
  BE99997: "Preceding Scenario Check DB Timeout",
  BE99998: "Preceding Scenario Timeout DB Check",
  E010101: "Switching Rules Exceed 200",
  E010102: "Hybrid Tariff not supported for SMETS1",
  E010105: "Neither a Price Matrix or Block Prices element has been specified",
  E010106: "General error building a Tariff Rate Script",
  E010107: "A Block Tariff is specified without a Threshold Matrix",
  E010108: "Too many switching profile elements. Exceeds 48",
  E010109: "A referenced Week Profile does not exist",
  E010110: "A referenced Day Profile does not exist",
  E010111:
    "Block Threshold 2 missing when Block Threshold 3 has been specified",
  E010112:
    "Block Threshold 1 missing when Block Threshold 2 has been specified",
  E010115: "A referenced Week Name does not exist",
  E010116: "A referenced Day Name does not exist",
  E010117:
    "A referenced Day Profile contains a TOU Tariff Action that does not exist in the Price Matrix",
  E010118: "A Special Day has a referenced Day Profile that does not exist",
  E010119:
    "A Switch Profile has a referenced TOU Tariff Action that does not exist",
  E010201: "Hybrid Price not supported for SMETS1",
  E010204: "Neither a Price Matrix or Block Prices element has been specified",
  E020101: "Non-disablement schedule does not apply to all days of week",
  E020107: "A Special Day contains a Stop Action",
  E020108: "More than 1 All Day Schedule has been specified",
  E020110: "Special Days do not correspond to Schedule Calendar entries",
  E020111: "Schedule entries exceed 29",
  E020113: "Schedules are not specified for each day of the week",
  E020115: "The number of Day Profiles exceeds 8",
  E020119: "Non-disconnect Schedules and Special Days exceed 49",
  E020301: "No Debt Recovery Rates specified (Electricity)",
  E020303: "No Debt Recovery Rates specified (Gas)",
  E030301: "Log Type Invalid",
  E030302: "Invalid HCALCS Event Log Clear On SMETS1 Device",
  E040101: "Failed Validation - Device Type / User Role mismatch",
  E040301: "EMC status reported by the device is unknown",
  E041701: "Failed Validation - Log period does not span at least 1 midnight",
  E050101: "Failed Validation - Schedule Start Date not in the future",
  E050103: "Failed Validation - Schedule End Date missing",
  E050105:
    "Failed Validation - DSP Service Reference and DSP Service Reference Variant mismatch",
  E050108:
    "Failed Validation - Maximum Number of DCC Service User DSP Schedules for Device already exist",
  E050109:
    "Failed Validation - DSP Service Request Format and DSP Service Reference Variant mismatch",
  E050110:
    "Failed Validation - DSP Service Reference Variant Not applicable to Device SMETS version",
  E050201: "Invalid DSP Schedule ID",
  E050202: "The Device ID doesn't exist",
  E050301: "Failed to Delete Schedule - DSP Schedule ID invalid",
  E050302: "Failed to Delete Schedules - Invalid Device ID",
  "E050302 ": "Failed to Delete Schedules - Invalid Device ID",
  E060701: "Element provided not applicable to device GBCS version",
  E060801: "Device Type is invalid for the Billing Calendar",
  E060802:
    "DCC validation - The Billing Period Start Date day of the month is 29, 30 or 31",
  E060803:
    "GBCS version for the Firmware on the Device does not support the features chosen in the Service Request",
  E061301: "The Log To Read type invalid",
  E061304: "The Service User Role invalid",
  E061305:
    "Read Type Invalid For SMETS1 Device/Requested log not applicable for SMETS1 Device",
  E061501:
    "DCC Service User Role/Remote Party Role/Certificate/Device Type Mismatch",
  E061504: "Invalid Remote Party Prepayment Top Up Floor Seq Number",
  E061505: "Certificate Type/Device Type mismatch",
  E061506: "Request is Future Dated Remote Party Role is not Supplier",
  E061507: "Remote Party Role/Role Code/Certificate Type mismatch",
  E062101: "Invalid Remote Party Prepayment Top Up Floor Seq Number",
  E062102: "The Certificate Type is not Applicable to the Device Type",
  E062103: "DCC Service User Role/Remote Party Role mismatch",
  E062105:
    "Certificate Type/Device Type/Remote Party Role mismatch or Missing Certificate(s)",
  E062201: "Invalid Request due to Failed Validation",
  E062202: "Service Request is not applicable to the ESME variant",
  E062203: "SR Does Not Align to Device GBCS Version",
  E062301: "Invalid MPxN",
  E062302: "Invalid Supplier PP Top Up Seq No",
  E062303: "Device Type/Certificate Type mismatch",
  E062304: "Failed Validation - Service User / Certificate mismatch",
  E062305:
    "CoS Party / Certificate mismatch - The target Device holds a CoS Certificate in the CoS Party Trust Anchor Cell that is not an active CoS Party Certificate",
  E062306:
    "Incorrect MPID - The MPID included within the Certificate that is used to sign the Request does not correspond to the Registered Supplier for the MPxN associated with the Device",
  E062401: "Device Type / User Mismatch",
  E062801: "Required Sub GHz channels are missing",
  E062802: "At least 2 Lower Band Sub GHz Page Masks",
  E062803:
    "Invalid LimitedCriticalDutyCycleThreshold and NormalLimitedDutyCycleThreshold",
  E080201: "The request does not uniquely identify a premises",
  E080202: "The premises do not contain any devices",
  E080301: "Invalid Device Status",
  E080302: "Device Type is Invalid",
  E080303: "If the GDSP SIM status change has failed",
  E080405: "Incorrect Device Status",
  E080406: "Invalid Device Transition",
  E080407: "DeviceID does not exist or status in a pending state",
  E080408: "No Update Detail",
  E080409: "Device Details Do Not Match CPL",
  E080411: "Request not valid for target device",
  E080412: "The Device Status transition is not valid for CHF",
  E080413:
    "MPxN request not valid for target device/Device is not an ESME device",
  E080414:
    "Device status invalid/Device not at an allowable status for MPxN update",
  E080415: "Requestor not the registered supplier for the new MPxN",
  E080702: "Other Device Type Invalid",
  E080703: "If the join device is not an IHD",
  E080704: "If the join device cannot be found in the FE Inventory",
  E080721: "'Other Device' Type is not valid",
  E080722: "Invalid DCC Service User Role for Device Type",
  E080723: "Invalid DCC service user for Join Type",
  E080724: "If the join device type is not: ESME, GSME, GPF or IHD",
  E080726: "If the join device cannot be found in the FE Inventory",
  E080801: "Other device is not joined to Target Device",
  E080821: "Invalid Service User for Device Type",
  E080822: "Invalid Service User for Join Type",
  E080901: "Read Device Log Not Targeting SMETS1 CHF",
  E080902:
    "Failed Authorisation - GBCS Firmware Version does not support ReadSecurityDetails",
  E080903:
    "Failed Authorisation - Device Type does not support ReadSecurityDetails",
  E081101: "Device ID Already Paired",
  E081102: "Device ID Not Valid",
  E081104: "Invalid Device Type",
  E081105: "Invalid Device Status",
  E081106: "Data Invalid",
  E081107: "Device does not exist in SMI",
  E081108: "Invalid Service User Role for DeviceType",
  E081109: "Not the Registered Supplier",
  E081110: "Invalid MPAN Type",
  E081111:
    "S1 = If an Add is specified and a MAC Address is not in the request / S2 = Failed Validation - Invalid Install Code length",
  E081202: "Invalid Old CHF Device ID",
  E081204: "Invalid New CHF Device Status",
  E081205: "DCC Service User Unable to Access Old CHF Device ID",
  E081221: "Invalid Old GPF Device Type",
  E081222: "Invalid New GPF Device Status",
  E081223: "DCC Service User Unable to Access the GPF Associated to the GPF",
  E081401: "Invalid Device Type",
  E081402: "Install Date in the Future",
  E081405: "Install Date in the Future",
  E1: "Failed Authorisation - Invalid User / User Role",
  E1001:
    "Failed Validation - Log Period Start Date Time later than required execution date-time",
  E1003:
    "Failed Validation - Log Period End Date Time earlier than Start Date Time",
  E1007: "Failed Validation - Invalid Security Credentials",
  E1008: "The Device Id or Serial number does not exist in the FE Inventory",
  E1010:
    "Failed Validation - Invalid Request ID / Originator Counter value / Responsible Supplier",
  E1011: "Failed Validation - Device not a Dual Band Communications Hub",
  E11: "Failed Validation - Invalid Service Request / device type combination",
  E110101: "Firmware not on CPL",
  E110102: "Invalid Firmware Status",
  E110103: "Invalid Firmware Hash",
  E110105: "Invalid Format of Firmware Image",
  E110401: "Firmware Version not approved",
  E110402: "Firmware not active",
  E110403: "Invalid Firmware Hash",
  E110405: "Firmware image not correctly formed",
  E120101: "No Location Identified",
  E120102: "WAN data not available",
  E120201: "Invalid Device Status",
  E120203: "Invalid Request",
  E120204: "Inconsistent Request",
  E120207: "Invalid Device Type",
  E17: "Failed Authorisation - Invalid DCC User Role / Device for locally delivered Commands",
  E19: "Failed Authorisation - Device doesn't exist",
  E2: "Failed Authorisation - Invalid User Role / Service Reference",
  E20: "Communications Failure - Unable to Communicate with Device",
  E2000:
    "Check Cryptographic Protection for Countersigned Service Request failed to validate the DCC Digital Signature.",
  E2001:
    "S1SP is not the relevant S1SP for the Device(s) identified in the Countersigned Service Request",
  E2003: "Internal DCO Error",
  E2004: "S1SP Internal Error",
  E21: "Communications Failure - No Response Received from Device",
  E3: "Failed Authorisation - Invalid User Status",
  E4: "Failed Authorisation - Invalid User / User Role for Device",
  E5: "Failed Authorisation - Invalid Device Status",
  E57: "Failed Validation - Invalid Service Request / GBCS version combination",
  E60: "SR not supported for SMETS1",
  E62: "S1SP Alert - Validation Error or Other Notification received from Device",
  E64: "SR's User ID not matching DCC",
  W050201: "No Schedule Set on the Device",
  W050301:
    "DCC Validation - DCC Service User holds no active schedules on the Device",
  W081401: "Incompatible Device Status",
  W110101: "Device IDs are Invalid",
  W110401: "Firmware Version not applicable to Device",
} as const

export const alertCodes = {
  "8F1D": "LGSME Power Supply Loss",
  "8F1F": "Low Battery Capacity",
  "8F3F": "Unauthorised Physical Access - Tamper Detect",
  "8F73": "Unauthorised Physical Access - Battery Cover Removed",
  "8F74": "Unauthorised Physical Access - Meter Cover Removed",
  "8F75": "Unauthorised Physical Access - Strong Magnetic field",
  "8F76": "Unauthorised Physical Access - Terminal Cover Removed",
  "8F77": "Unauthorised Physical Access - Second Terminal Cover Removed",
  "8F78": "Unauthorised Physical Access - Other",
  "81BB": "Reverse Current",
  "81C4": "UTRN Manual Entry Suspended",
  "81C5": "UTRN rejected as locked out",
  "8F83": "Disablement of Supply due to insufficient credit has been suspended",
  "81B6": "Flow Sensor Detects Reverse Flow of Gas",
  N46: "Quarantined Request - Anomaly Detection User Threshold Breach",
  N47: "Quarantined Request - Anomaly Detection DCC Threshold Breach",
  N48: "Quarantined Request - Anomaly Detection Attribute Limits Breach",
} as const

export const workstreamStatuses = {
  working: {
    text: "Communicating",
    type: "normal",
  },
  inherited: {
    text: "Inherited",
    type: "critical",
  },
  inlifeissue: {
    text: "In-life issue",
    type: "critical",
  },
  uncommissioned: {
    text: "Uncommissioned",
    type: "critical",
  },
} as const

export const modelNameMapping = {
  "00000000": "SGM1412 (S2 ESME )",
  "00000100": "SGM1412B (S2 ESME)",
  "00000101": "AS302P (S2 ESME)",
  "00000107": "SGM1412B (S2 ESME)",
  "00000108": "SGM1412B (S2 ESME)",
  "00000201": "AS302P (S2 ESME)",
  "00000207": "SGM1411B (S2 ESME)",
  "00000208": "SGM1411B (S2 ESME)",
  "00000212": "MMU6 (2.4GHz S2 GSME)",
  "00000300": "G4SZV-2 (S2 GSME)",
  "00000301": "SGM1415B (5 Terminal S2 ESME)",
  "00000302": "SGM1415B (S2 ESME)",
  "00000401": "SGM1416B (5 Terminal S2 ESME)",
  "00000402": "SGM1416B (5 Terminal S2 ESME)",
  "00000501": "SGM1422B (Twin Element S2 ESME)",
  "00000502": "SGM1422B (Twin Element S2 ESME)",
  "00000601": "SGM1431B (Polyphase S2 ESME)",
  "00000602": "SGM1431B (Polyphase S2 ESME)",
  "00000701": "SGM1432B (Polyphase S2 ESME)",
  "00000702": "SGM1432B (Polyphase S2 ESME)",
  "00000801": "SGM1433B (Polyphase S2 ESME)",
  "00000802": "SGM1433B (Polyphase S2 ESME)",
  "00000900": "G4SZV-2 (S2 GSME)",
  "00010600": "G4-6UDZV-2 (S2 GSME)",
  "00020101": "E470-5299A (S1 ESME)",
  "00020200": "SGM1312 (S1 ESME)",
  "00030201": "E470-5394 (S2 ESME)",
  "00030202": "E470-5394 (S2 ESME)",
  "00030600": "G4-6UDZV-2 (S2 GSME)",
  "00040101": "E470-5394 (S1 ESME)",
  "00050202": "E470-5424 (S2 ESME)",
  "00050203": "E470-5424 (S2 ESME)",
  "00050204": "E470-5533 (S2 ESME)",
  "00060204": "E470 (S2 ESME)",
  "00006612": "MMU6 Dual Band (Double Band, Thermal Mass S2 GSME)",
  "03000101": "AS300P (S1 ESME)",
  "05730000": "BK-G4E (Diaphragm S1 GSME)",
  "05740101": "BK-G4E (Diaphragm (EI5) S1 GSME)",
  "05750000": "BK-G4E (Diaphragm S2 GSME)",
  "05750101": "BK-G4E (Diaphragm S2 GSME)",
  "05750102": "BK-G4E (Diaphragm S2 GSME)",
  "09B31F00": "G4SZV (Diaphragm S1 GSME)",
  "09B33200": "G4SZV-1 (Diaphragm S2 GSME)",
  "09B33700": "G4SZV-1 (Diaphragm S2 GSME)",
  "10E101FF": "ES-10A (S2 ESME)",
  "10E1A100": "ES-10A (S2 ESME)",
  "10E2A100": "ES-10B (S2 ESME)",
  "10F101FF": "GS-60A (Ultrasonic S2 GSME)",
  "10F1A100": "GS-60A (Ultrasonic S2 GSME)",
  "10F2A100": "GS-60B (Ultrasonic S2 GSME)",
  "10F3A100": "GS-68B (868MHz S2 GSME)",
  "11111111": "G4-MG-SE-GM-V2 FVI (Diaphragm: Front Viewing Index S2 GSME)",
  "11111211": "G4-MG-SE-GM-V2 TVI (Diaphragm: Top Viewing Index S2 GSME)",
  "11121111":
    "G4-MG-SE-GM-V2-DB FVI (Double Band, Diaphragm, Front Viewing Index S2 GSME)",
  "11121211":
    "G4-MG-SE-GM-V2-DB TVI (Double Band, Diaphragm, Top Viewing Index S2 GSME)",
  "12E2A100": "ES-12B (5 Terminal S2 ESME)",
  "20000000": "RF1SVZB (Diaphragm S1 GSME)",
  "30E5A100": "ES-30B (Polyphase S2 ESME)",
  "31320501": "MA120 (S2 ESME)",
  "31324034": "MA120 (S2 ESME)",
  "31324130": "MA120 (S2 ESME)",
  "31324131": "MA120 (S2 ESME)",
  "31334330": "MA120B (5 Terminal S2 ESME)",
  "31384230": "MA120 (S2 ESME)",
  "31394430": "MA120B (5 Terminal S2 ESME)",
  "33325031": "MA329B (Polyphase S2 ESME)",
  "33325033": "MA329B (Polyphase S2 ESME)",
  "33325130": "MA329B (Polyphase S2 ESME)",
  "37710001": "E6VG370 (Ultrasonic S1 GSME)",
  "47820101": "G470-682 (868MHz S2 GSME)",
  "47710001": "E6VG370 (Ultrasonic S1 GSME)",
  "47710101": "E6VG470 (Ultrasonic S1 GSME)",
  "47720101": "G470-672 (Ultrasonic S2 GSME)",
  "47720201": "G470-672 (S2 GSME)",
  "56780201": "EM425-UK (S1 ESME)",
  A0A1013D: "LIBERTY 101 (S2 ESME)",
  B0A10144: "LIBERTY GAS 200 (S2 GSME)",
  B0A20172: "LIBERTY GAS 200 (868MHz S2 GSME)",
  C0A10101: "LIBERTY 100 (S1 ESME)",
  C0A10102: "LIBERTY 100 (S1 ESME)",
  C0A10171: "LIBERTY 116 (5 Terminal S2 ESME)",
  C1A10201: "LIBERTY 110 (S1 ESME)",
  C2A10301: "LIBERTY 111/112 (S1 ESME)",
  C3A10401: "LIBERTY 113/114 (S1 ESME)",
  C4A10501: "EG4V10 / EG4V11 (Diaphragm S1 GSME)",
  C5A10601: "EG4V15 (Diaphragm S1 GSME)",
  C901A500: "FGBB03 (Ultrasonic S2 GSME)",
  C902A500: "FGBB03 (Double Band S2 GSME)",
  D7000103: "EM425-UK2 (S2 ESME)",
  D7000105: "EM425-UK2 (S2 ESME)",
} as const

export const manufacturerNameMapping = {
  "1015": "Develco/Flonidan",
  "1028": "Itron Metering Solutions (UK) Ltd",
  "1031": "Secure Meters (UK) Ltd",
  "1057": "Honeywell (Elster Metering Ltd)",
  "1063": "Landis + Gyr Ltd",
  "106C": "EDMI Europe Ltd",
  "1072": "WNC (Wistron NeWeb Corp)",
  "1086": "Toshiba Information Systems (UK) Ltd",
  "1090": "GEO (Green Energy Options Ltd)",
  "10C7": "Trilliant Networks (UK) Ltd",
  "10E0": "Chameleon Technology (UK) Ltd",
  "1125": "Kaifa Technology UK Ltd",
  "1128": "IHDL (In Home Displays Limited)",
  "116A": "Holley Technology UK Ltd",
  "118F": "Aclara Meters UK Ltd (formerly GE)",
  "1191": "Goldcard",
  "1192": "GWI (George Wilson Industries Ltd)",
  "119A": "SLS (System Level Solutions Corp)",
  "120F": "Presciense Ltd",
  "123E": "Develco/Flonidan",
  "1264": "MeteRsit s.r.l",
} as const
